@use "variables" as *;

.wrapper {
  width: fit-content;
  display: flex;
  align-items: center;
  column-gap: 9px;
}

.select {
  min-width: 85px;
}

.dropdownLabel {
  margin-right: $spacing-2;
  color: $content-secondary-color;
}
